import { render, staticRenderFns } from "./BubbleCounselorButtons.vue?vue&type=template&id=567a3788&scoped=true&"
import script from "./BubbleCounselorButtons.vue?vue&type=script&lang=js&"
export * from "./BubbleCounselorButtons.vue?vue&type=script&lang=js&"
import style0 from "./BubbleCounselorButtons.vue?vue&type=style&index=0&id=567a3788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a3788",
  null
  
)

export default component.exports